/**
 * Wird anstelle des Portals gezeigt, wenn ein Modul-Manifest fehlerhaft ist.
 *
 * Bewusst ohne Design-System und ohne Router: an dieser Stelle steht noch
 * nichts, worauf man sich verlassen könnte. Wichtig ist nur, dass der
 * Modulentwickler den Fehlertext vollständig und lesbar vor sich hat.
 */
export function ManifestErrorPage({ error }: { error: Error }) {
  return (
    <div
      style={{
        fontFamily: 'Segoe UI, system-ui, sans-serif',
        maxWidth: '52rem',
        margin: '3rem auto',
        padding: '0 1.5rem',
        color: '#102757',
      }}
    >
      <h1 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>
        Das Portal konnte nicht starten
      </h1>
      <p style={{ marginTop: 0, color: '#5a5a5a' }}>
        Ein Modul ist nicht korrekt beschrieben. Die Meldung sagt, welche Datei
        betroffen ist und was dort fehlt.
      </p>
      <pre
        style={{
          background: '#F2F2F2',
          border: '1px solid #d4d4d4',
          borderRadius: '0.5rem',
          padding: '1rem',
          overflowX: 'auto',
          whiteSpace: 'pre-wrap',
          fontSize: '0.875rem',
          lineHeight: 1.6,
        }}
      >
        {error.message}
      </pre>
    </div>
  )
}
